import request from "@/utils/request";

export default {
    query: (log) => {
        return request({
            url: '/intf-call-log/query',
            method: 'post',
            data: log
        })
    },
}
